import { EmblaCarouselType } from 'embla-carousel';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import {
  ReactZoomPanPinchRef,
  TransformComponent,
  TransformWrapper
} from 'react-zoom-pan-pinch';

import BigArrowIcon from '@/fo/icons/base/icons/big-arrow.svg';

import { LightboxImage as LightboxImageType } from '../../types';

import { styles } from './LightboxImage.styles';

export interface LightboxImageProps {
  image: LightboxImageType;
  emblaApi?: EmblaCarouselType;
  active?: boolean;
  onOpenReview?: (id: string) => void;
}

export function LightboxImage({
  image,
  emblaApi,
  active,
  onOpenReview
}: LightboxImageProps) {
  const slots = styles();

  const t = useTranslations();

  const [zoom, setZoom] = useState(false);

  const handlePanningStart = () => {
    if (emblaApi && zoom) {
      emblaApi.reInit({ watchDrag: false });
    }
  };

  const handlePanningEnd = () => {
    if (emblaApi && zoom) {
      emblaApi.reInit({ watchDrag: true });
    }
  };

  const handleZoom = (ref: ReactZoomPanPinchRef) => {
    setZoom(+ref.state.scale.toFixed(2) !== 1);
  };

  const reviewId = image.review?.id;

  return (
    <div className={slots.base()}>
      <TransformWrapper
        doubleClick={{ mode: 'toggle' }}
        panning={{
          disabled: !zoom
        }}
        maxScale={1.5}
        disablePadding
        onPanningStart={handlePanningStart}
        onPanningStop={handlePanningEnd}
        onWheelStop={handleZoom}
        onZoomStop={handleZoom}
      >
        <TransformComponent
          wrapperStyle={{ height: '100%', width: '100%' }}
          contentStyle={{
            height: '100%',
            width: '100%',
            cursor: zoom ? 'move' : 'zoom-in'
          }}
        >
          <Image
            src={image.src}
            alt={image.alt}
            className={slots.image()}
            fill
          />
        </TransformComponent>
        {active && reviewId && (
          <div className={slots.active()}>
            <button
              type="button"
              onClick={() => onOpenReview?.(reviewId)}
              className={slots.button()}
            >
              <span className={slots.buttonText()}>
                {t('review.buttons.readReview')}
              </span>
              <BigArrowIcon />
            </button>
          </div>
        )}
      </TransformWrapper>
    </div>
  );
}
